<template>
  <div>
    <div :class="[
      'received-sent-status',
      setText.includes('?') ? 'pending' : '',
      setText.includes('not') ? 'rejected' : '',
    ]" v-if="!fetching">
      <span :data-cy="`requestStatus-${item.title}`">
        {{ setText }}
      </span>
      <div class="set-sent-not-sent">
        <md-button
          class="d-inline md-icon-button md-raised md-fab button-status"
          @click.prevent="setItemStatus('accept')"
          v-if="!choice && setText.includes('?')"
          :data-cy="`acceptRequest-${item.title}`"
        >
          <md-icon>done</md-icon>
        </md-button>

        <md-button
          class="d-inline md-icon-button md-raised md-fab button-status"
          @click.prevent="setItemStatus('reject')"
          v-if="!choice && setText.includes('?')"
          :data-cy="`declineRequest-${item.title}`"
        >
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </div>
    <LoadingSpinner position="absolute" v-else />
  </div>
</template>

<script>
import itemType from "@/enum/item-type";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import itemStatus from "@/enum/item-status";
import PointsHelperVue from "@/mixins/PointsHelper.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";

export default {
  name: "ItemReceivedSentStatus",
  props: ["item", "acceptedRequest"],
  mixins: [ItemHelperVue, PointsHelperVue, UserHelperVue],
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      choice: false,
      action: "",
      item_status: itemStatus,
      fetching: false,
      updatedItem: this.item,
      pointsReceiverId: null,
      pointsGiverId: null,
      valuePoints: 0,
      note: `trade canceled for the item <a href="/s-app/item-details/${this.itemid}">${this.item.title}</a>`,
    };
  },
  computed: {
    getClass() {
      return this.class;
    },
    setText() {
      if (this.item && this.item.type !== undefined) {
        let status = this.item.status;
        let requesterName = this.getRequestUserName(this.acceptedRequest);
        let posterName = this.getPosterName(this.item);

        if (status === itemStatus.WAITING) {
          return this.setWaitingItemText()
        } else if (status === itemStatus.SENT) {
          return this.setSentItemText(requesterName, posterName);
        } else if (status === itemStatus.RECEIVED) {
          return this.setReceivedItemText(requesterName, posterName);
        } else if (status === itemStatus.NOT_SENT) {
          return this.setNotSentItemText(requesterName, posterName);
        } else if (status === itemStatus.NOT_RECEIVED) {
          return this.setNotReceivedItemText(requesterName, posterName)
        }
      }
      return "";
    },
  },
  methods: {
    setWaitingItemText() {
      if (
        itemType.GIVE === this.item.type ||
        itemType.LEND === this.item.type
      ) {
        if (this.loggedUser.id === this.item.posterId) {
          return `Have you sent this item?`;
        } else {
          return `Have you received this item?`;
        }
      } else {
        if (this.loggedUser.id === this.item.posterId) {
          return `Have you received this item?`;
        } else {
          return `Have you sent this item?`;
        }
      }
    },
    setSentItemText(requesterName, posterName) {
      if (
        itemType.GIVE === this.item.type ||
        itemType.LEND === this.item.type
      ) {
        if (this.loggedUser.id === this.item.posterId) {
          return `Item sent to ${requesterName}.`;
        } else {
          return `Have you received this item?`;
        }
      } else {
        if (this.loggedUser.id === this.item.posterId) {
          return `Have you received this item?`;
        } else {
          return `Item sent to ${posterName}.`;
        }
      }
    },
    setReceivedItemText(requesterName, posterName) {
      if (
        itemType.GIVE === this.item.type ||
        itemType.LEND === this.item.type
      ) {
        if (this.loggedUser.id === this.item.posterId) {
          return `Item received by ${requesterName}.`;
        } else {
          return `Item received from ${posterName}.`;
        }
      } else {
        if (this.loggedUser.id === this.item.posterId) {
          return `Item received from ${requesterName}.`;
        } else {
          return `Item received by ${posterName}.`;
        }
      }
    },
    setNotSentItemText(requesterName, posterName) {
      if (
        itemType.GIVE === this.item.type ||
        itemType.LEND === this.item.type
      ) {
        if (this.loggedUser.id === this.item.posterId) {
          return `Item not sent to ${requesterName}.`;
        } else {
          return `Item not sent by ${posterName}.`;
        }
      } else {
        if (this.loggedUser.id === this.item.posterId) {
          return `Item not sent by ${requesterName}.`;
        } else {
          return `Item not sent to ${posterName}.`;
        }
      }
    },
    setNotReceivedItemText(requesterName, posterName) {
      if (
        itemType.GIVE === this.item.type ||
        itemType.LEND === this.item.type
      ) {
        if (this.loggedUser.id === this.item.posterId) {
          return `Item not received by ${requesterName}.`;
        } else {
          return `Item not received from ${posterName}.`;
        }
      } else {
        if (this.loggedUser.id === this.item.posterId) {
          return `Item not received from ${requesterName}.`;
        } else {
          return `Item not received by ${posterName}.`;
        }
      }
    },
    setGiveOrLendItemStatus(action) {
      if (action === "accept") {
        if (this.loggedUser.id === this.item.posterId) {
          this.updatedItem.status = itemStatus.SENT;
        } else {
          this.updatedItem.status = itemStatus.RECEIVED;
        }
      } else {
        if (this.loggedUser.id === this.item.posterId) {
          this.updatedItem.status = itemStatus.NOT_SENT;
          this.valuePoints = this.item.points || this.item.cash;
        } else {
          this.updatedItem.status = itemStatus.NOT_RECEIVED;
          this.valuePoints = this.item.points || this.item.cash;
        }
        this.pointsReceiverId = this.acceptedRequest.sUserId;
        this.pointsGiverId = this.item.posterId;
      }
    },
    setReceiveOrBorrowItemStatus(action) {
      if (action === "accept") {
        if (this.loggedUser.id === this.item.posterId) {
          this.updatedItem.status = itemStatus.RECEIVED;
        } else {
          this.updatedItem.status = itemStatus.SENT;
        }
        this.note = this.setText;
      } else {
        if (this.loggedUser.id === this.item.posterId) {
          this.updatedItem.status = itemStatus.NOT_RECEIVED;
          this.valuePoints = this.item.points || this.item.cash;
        } else {
          this.updatedItem.status = itemStatus.NOT_SENT;
          this.valuePoints = this.item.points || this.item.cash;
        }
        this.pointsReceiverId = this.item.posterId;
        this.pointsGiverId = this.acceptedRequest.sUserId;
      }
    },
    async setItemStatus(action) {
      this.$emit("updateItemStatus");

      if (this.item && this.item.type !== undefined) {
        this.action = action;
        let type = this.item.type;

        if (type === itemType.GIVE || type === itemType.LEND) {
          this.setGiveOrLendItemStatus(action);
        } else if (type === itemType.RECEIVE || type === itemType.BORROW) {
          this.setReceiveOrBorrowItemStatus(action);
        }
        try {
          let result = null;
          this.fetching = true;
          result = await this.updateItemStatus({ item: this.updatedItem });
          this.fetching = false;
          if (result.result === "Item updated!" && this.action === "reject") {
            await this.transferPoint({
              to_id: this.pointsReceiverId,
              from_id: this.pointsGiverId,
              value: this.valuePoints,
              note: this.note,
            });
          }
        } catch (error) {
          console.log(error);
        }
        this.choice = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mypost-item-status {
  padding-right: 1.3rem;
  .received-sent-status {
    width: unset;
    max-width: 300px;
    display: block;
    margin-top: 0;
  }
}
.received-container {
  text-align: -webkit-center;
}
.received-sent-status {
  width: 100%;
  height: 100%;
  background: rgba(5, 145, 155, 0.07);
  border-radius: 4px;
  padding: 0.5rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  span {
    font-weight: 500;
    font-size: 14px;
    color: rgba(0,0,0, .8) !important;
    letter-spacing: 1.25px;
    text-align: center;
  }
}
.received-sent-status.rejected span{
  // border: 1px solid red;
  color: red !important
}
.received-sent-status.rejected{
  border: 1px solid red;
}
.button-status {
  width: 28px;
  height: 28px;
}
</style>


<style lang="scss">
.set-sent-not-sent {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  .md-button:last-child {
    margin-left: 7px;
  }
  .md-button:first-child .md-ripple {
    background: $primary;
  }
  .md-button:last-child .md-ripple {
    background: $danger;
  }
  i {
    color: $white !important;
  }
}
</style>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .received-sent-status {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
  }
}
</style>
